/*------------------------------------------------
// File Name:tGY_Base_Config.js
// File Description:tGY_Base_Config store方法
// Author:zxl
// Create Time:2024/04/01 11:00:51
//------------------------------------------------*/

import {
    GettGY_Base_ConfigList,
    GettGY_Base_ConfigListByPage,
    GettGY_Base_ConfigEntity,
    CreatetGY_Base_ConfigEntity,
    UpdatetGY_Base_ConfigEntity,
    DeletetGY_Base_ConfigEntity,
} from '@/api/gy/base/baseConfig'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const TgyBaseConfig = {
    namespaced: true,
    state: {
        TgyBaseConfigList: [],
        TgyBaseConfigListLoading: false,
        TgyBaseConfigEntity: null,
        TgyBaseConfigShowDlg: false,
    },
    mutations: {
        setTgyBaseConfigList(state, dataList) {
            state.TgyBaseConfigList = [...dataList]
        },
        setTgyBaseConfigListLoading(state, visible) {
            state.TgyBaseConfigListLoading = visible
        },
        setTgyBaseConfigShowDlg(state, visible) {
            state.TgyBaseConfigShowDlg = visible
        },
        setTgyBaseConfigEntity(state, entity) {
            state.TgyBaseConfigEntity = entity
        },
    },
    actions: {
        //创建整项目配置表对象
        actCreateTgyBaseConfig({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatetGY_Base_ConfigEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setTgyBaseConfigEntity', res.Data)
                        commit('setTgyBaseConfigShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载整项目配置表对象
        actGetTgyBaseConfigEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setTgyBaseConfigListLoading', true)
                GettGY_Base_ConfigEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setTgyBaseConfigEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setTgyBaseConfigListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载整项目配置表列表
        actGetTgyBaseConfigList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setTgyBaseConfigListLoading', true)
                GettGY_Base_ConfigList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setTgyBaseConfigList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setTgyBaseConfigListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载整项目配置表列表
        actGetTgyBaseConfigListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setTgyBaseConfigListLoading', true)
                GettGY_Base_ConfigListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setTgyBaseConfigList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setTgyBaseConfigListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存整项目配置表信息
        actUpdateTgyBaseConfig({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatetGY_Base_ConfigEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setTgyBaseConfigShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑tGY_Base_Config
        actEditTgyBaseConfigData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    TgyBaseConfigID : entity.TgyBaseConfigID
                }
                GettGY_Base_ConfigEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setTgyBaseConfigEntity', res.Data)
                        commit('setTgyBaseConfigShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑tGY_Base_Config ,传对象过来
        actEditTgyBaseConfig({ commit }, entity) {
            return new Promise(() => {
                commit('setTgyBaseConfigEntity', entity)
                commit('setTgyBaseConfigShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除tGY_Base_Config
        actDeleteTgyBaseConfig({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前整项目配置表？").onOk(() => {
                    DeletetGY_Base_ConfigEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setTgyBaseConfigShowDlg', false)
                           
                            msg.success("删除整项目配置表成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除整项目配置表失败，原因:" + res.Message)
                            //msg.success("删除整项目配置表失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


